import React, { ReactNode } from "react";
import {
	Modal,
	Box,
	Typography,
	Button,
	TextField,
	Select,
	MenuItem,
} from "@mui/material";
interface ReusableModalProps {
	open: boolean;
	onClose: () => void;
	title: ReactNode;
	content: ReactNode;
	actions: ReactNode;
	width?: number;
}
const ReusableModal: React.FC<ReusableModalProps> = ({
	open,
	onClose,
	title,
	content,
	actions,
	width = 1200,
}) => {
	return (
		<Modal open={open} onClose={onClose}>
			<Box
				sx={{
					width: width,
					maxHeight: "90vh", // Limit height to 90% of viewport height
					backgroundColor: "white",
					p: 3,
					borderRadius: 2,
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)", // Center the modal
					boxShadow: 24,
					outline: "none", // Optional: remove the focus outline
					overflowY: "auto", // Enable vertical scrolling
				}}
			>
				{/* Modal Title */}
				<Typography variant="h6" mb={2}>
					{title}
				</Typography>

				{/* Dynamic Content */}
				<Box mb={2} sx={{ overflowY: "auto" }}>{content}</Box>

				{/* Dynamic Footer Actions */}
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						gap: 2,
					}}
				>
					{actions}
				</Box>
			</Box>
		</Modal>
	);
};

export default ReusableModal;
